export const radarConfig = {
    fps: false,
    timing: false,
    radar: {
        projectId: /^\/html\/mulight-web\/(app|activity)/.test(location.pathname) ? '69aea1c5a9' : '601107b06a', // 雷达平台上的唯一标识
        sampling: 1, // 上报采样率，1 为全部上报
    },
};

export const wechatConfig = {
    // 皮艇
    // appid: 'wx41a0c03df5f2760d'
    // 回森
    appid: 'wxa00dac0042e12dd4'
};

export const defaultOpenConfig = {
    appConf: {
        ios: 'imv://',
        android: 'com.kwai.hisense',
    },
    wxAppId: wechatConfig.appid,
    // fbUrl: `${location.origin}/html/mulight-web/middleware/landPage/index.html`,
    fbUrl: 'https://h5.getkwai.com/html/mulight-web/middleware/landPage/index.html',
    universalLink: 'https://www.zhongnice.com/html/mulight-web/middleware/landPage/index.html',
};

// export const fakeUserId = undefined;
export const fakeAppVersion = '1.0.0';
// export const fakeUserId = 2419;  // 李伟 
// export const fakeUserId = 336321; // 高岩 
// export const fakeUserId = 139583; // 玉龙  
// export const fakeUserId = 363627; // 谢凯  
// export const fakeUserId = 427682; // 姜玫
